import { Grid, SxProps, Theme } from '@mui/material';
import { AppBadge } from 'shared/components/app-badge';
import { FormTextField } from 'shared/controls';
import { Product } from 'shared/types';
import { buildFieldNameWithIndex } from 'shared/utility';

const containerStyles: SxProps<Theme> = (theme: Theme) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(0.75),
});

interface ILineItemNotesProps {
  product: Product;
  editMode: boolean;
  index: number;
}
export function LineItemNotes({ product, editMode, index }: ILineItemNotesProps) {
  const buildFieldName = buildFieldNameWithIndex<Product>(index);
  return (
    <Grid item xs={12} lg sx={containerStyles}>
      {editMode ? (
        <AppBadge invisible={!product.lineItemNotes} badgeContent={'!'} fullWidth title={'Line Item Notes'}>
          <FormTextField name={buildFieldName('lineItemNotes')} label='Line Item Notes' multiline minRows={2} />
        </AppBadge>
      ) : (
        <FormTextField name={buildFieldName('lineItemNotes')} label='Line Item Notes' multiline minRows={2} disabled />
      )}
    </Grid>
  );
}
